import http from "./utils";
import { prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;

export const setFavorites: (payload: any) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/favorites/set`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const delFavorites: (payload: any) => Promise<any> | any = (payload) => {
  return http({
    url: `${prefix}/favorites/del`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const sortFavorites: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/favorites/set_sort`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const checkFavorites: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/favorites/check`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export const getFavoritesDetail: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/favorites/list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
